import React from "react";
import CoursePestanasNav from "../components/CoursePestanasNav";
import "./Temario.css";

function Rendimiento() {
  return (
    <div className="cds-campus-root">
      <CoursePestanasNav />
      <h2>Sección: Rendimiento</h2>
      <p>Aquí el usuario ve estadísticas y progreso.</p>
    </div>
  );
}

export default Rendimiento;
